import React from "react";

import './AppContainer.scss'

const AppContainer = ({columns, children}) =>
{
    const columnClass = columns === undefined || columns === 1 ? 'one-col' : 'two-col' ;

    return <div className='pp-estar-container'>
        <div className={'pp-app-container ' + columnClass}>
            {children}
        </div>
    </div>
}

export default AppContainer;
